import React from 'react';
import { ExternalAccountNameType } from '../UserIntegrations';

export interface ExternalAccountInfoProps {
    accountName: ExternalAccountNameType;
    externalAccount?: UserExternalAccountType;
    setUnlinkAccount: (accountName: ExternalAccountNameType) => void;
    editable: boolean;
    loading: boolean;
}
export function ExternalAccountInfo({
    accountName,
    externalAccount,
    editable,
    setUnlinkAccount,
    loading,
}: ExternalAccountInfoProps) {
    const accountUserName = externalAccount?.metadata?.preferred_username;

    return (
        <div>
            {accountName}: {externalAccount ? accountUserName || 'Enabled' : 'None'}
            {editable && externalAccount && (
                <>
                    {' '}
                    <i
                        className="fa-solid fa-check-circle text-success me-2"
                        title={`${accountName} account linked successfully`}
                    />
                    (
                    <button
                        className="link-button"
                        type="button"
                        onClick={() => setUnlinkAccount(accountName)}
                        disabled={loading}
                    >
                        Reset
                    </button>
                    )
                </>
            )}
        </div>
    );
}
